export default "__VITE_ASSET__DOKDukry__"